import styled from '@emotion/styled';
import MUICircularProgress from '@material-ui/core/CircularProgress';

import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

export const Container = styled.div`
  width: 888px;
`;

export const Loader = styled(MUICircularProgress)`
  color: ${COLORS.purpleHeart};
`;

export const Centered = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  padding-top: ${spacing.xxxGiant};
`;
